module.exports = __webpack_public_path__ + "static/img/hzyzydyf.c369578.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzyzydyf.jpg
// module id = gs9/
// module chunks = 1